import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Tooltip from 'components/Tooltip';
import Icon from 'components/commons/Icon';

import { Input, Label, Placeholder, StateIcon, IconWrapper } from './styles';

const showEvents = ['mouseenter', 'touchend'];
const hideEvents = ['mouseleave'];

const TextField = ({
  error,
  placeholder,
  invalid,
  valid,
  icon,
  iconProps,
  ...rest
}) => {
  const [isTooltip, setTooltip] = useState(false);
  const toggleTooltip = (isShow = null) => {
    setTooltip(prev => (isShow !== null ? isShow : !prev));
  };

  return (
    <Label data-invalid={invalid} data-valid={valid}>
      {icon && (
        <IconWrapper>
          <Icon name={icon} {...iconProps} />
        </IconWrapper>
      )}

      <Input {...rest} withIcon={!!icon} />

      <Placeholder withIcon={!!icon}>{placeholder}</Placeholder>

      <StateIcon data-valid={valid} data-invalid={invalid} data-tip-target />

      <Tooltip
        show={!!error && invalid && isTooltip}
        position="top"
        width={172}
        toggle={toggleTooltip}
        showEvents={showEvents}
        hideEvents={hideEvents}
      >
        {error}
      </Tooltip>
    </Label>
  );
};

export default TextField;

TextField.propTypes = {
  type: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  invalid: PropTypes.bool,
  valid: PropTypes.bool,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  iconProps: PropTypes.objectOf(PropTypes.any),
};

TextField.defaultProps = {
  type: '',
  value: '',
  error: '',
  placeholder: '',
  name: '',
  onChange: () => {},
  invalid: false,
  valid: false,
  disabled: false,
  icon: null,
  iconProps: {},
};
